// extracted by mini-css-extract-plugin
module.exports = {"image":"dP-z","loaded":"eP-z","placeholder":"fP-z"};